import axios, { AxiosInstance } from "axios";
import { environment } from "../environment/environment";
import Crypto from "./Crypto";

export class Client {
    private client: AxiosInstance;
    private privateKey: string;
    private system: string;

    constructor(baseURL: string, privateKey: string, system: string) {
        this.client = axios.create({
            baseURL,
            timeout: 5000,
        });
        this.privateKey = privateKey;
        this.system = system;
    }

    setHeader(key: string, value: string) {
        this.client.defaults.headers[key] = value;
    }

    async post(endpoint: string, data?: any): Promise<any> {
        try {
            // This is because dotenv package cant read \n
            // or literally new line so nimebadilisha new line na | na hapa chini ndo nabadilisha
            const pk = this.privateKey.replace(/\|/g, "\n");

            const token = localStorage.getItem("authToken"); // your access token
          

            let hashSignature = Crypto.sign(data, pk)
            const response = await this.client.post(endpoint, data || {}, {
                headers: {
                    "Content-Type": "application/json",
                    "SYSTEM-NAME": this.system,
                    "DATA-SIGNATURE": hashSignature.signature,
                    "DATA-HASH": hashSignature.hash,
                    "Authorization": token ? `Bearer ${token}` : "", // add Bearer token
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error in POST request:", error);
            throw error;
        }
    }

    async get(endpoint: string): Promise<any> {
        let data = "data"
        try {
            // This is because dotenv package cant read \n
            // or literally new line so nimebadilisha new line na | na hapa chini ndo nabadilisha
            const pk = this.privateKey.replace(/\|/g, "\n");

            let hashSignature = Crypto.sign(data, pk)
            const response = await this.client.get(endpoint, {
                headers: {
                    "Content-Type": "application/json",
                    "SYSTEM-NAME": this.system,
                    "DATA-SIGNATURE": hashSignature.signature,
                    "DATA-HASH": hashSignature.hash,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error in GET request:", error);
            throw error;
        }
    }
}

type ClientConfig = {
    baseURL: string;
    privateKey: string;
    systemName: string;
};

const clientMap = new Map<string, Client>();

type ServiceName = keyof typeof environment.SERVICES;

export const createClient = (serviceName: ServiceName, config?: ClientConfig): Client => {
    if (clientMap.has(serviceName)) {
        return clientMap.get(serviceName)!;
    }

    const serviceConfig = environment.SERVICES[serviceName];

    if (!serviceConfig) {
        throw new Error(`Configuration for service ${serviceName} not found`);
    }

    const baseURL = config?.baseURL || serviceConfig.API_BASE_URL;
    const privateKey = config?.privateKey || serviceConfig.PRIVATE_KEY;
    const systemName = config?.systemName || serviceConfig.SYSTEM_NAME;

    if (!baseURL || !privateKey || !systemName) {
        throw new Error(`Missing configuration for service: ${serviceName}`);
    }

    const newClient = new Client(baseURL, privateKey, systemName);
    clientMap.set(serviceName, newClient);
    return newClient;
};
export default createClient;